import React from 'react';
import { StepButtons } from '../ui';

interface AreaStepProps {
  value: {
    area: number;
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const AreaStep: React.FC<AreaStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    onChange('area', newValue);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Surface du bien</h2>
      
      <div>
        <label htmlFor="area" className="block text-sm font-medium text-neutral-700 mb-2">
          Surface en m²
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            id="area"
            value={value.area || ''}
            onChange={handleAreaChange}
            min="0"
            step="0.5"
            className="input w-full"
            placeholder="Entrez la surface"
          />
          <span className="text-neutral-500">m²</span>
        </div>
      </div>

      <StepButtons
        onNext={onNext}
        onBack={onBack}
        disabled={!value.area || value.area <= 0}
      />
    </div>
  );
};

export default AreaStep;